/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Group_Connecting_ToolsInputs */



/**
* | output |
* | --- |
* | "Connecting tools" |
*
* @param {Onboarding_Usage_Group_Connecting_ToolsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_group_connecting_tools = /** @type {((inputs?: Onboarding_Usage_Group_Connecting_ToolsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Group_Connecting_ToolsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tools verbinden")
	return /** @type {LocalizedString} */ ("Connecting tools")
});